// utils/encodingHelper.js
export const fixFrenchCharacters = (str) => {
    if (!str) return str;
    
    const encodingMap = {
      // Mapping des caractères mal encodés
      'Ã©': 'é', 'Ã¨': 'è', 'Ãª': 'ê', 'Ã¢': 'â',
      'Ã®': 'î', 'Ã´': 'ô', 'Ã»': 'û', 'Ã¹': 'ù',
      'Ã§': 'ç', 'Ã': 'à', 'Â': '', // Â est souvent un artefact
      '�': 'é' // Fallback pour les cas extrêmes
    };
  
    return str.replace(/[^\x00-\x7F]/g, match => {
      return encodingMap[match] || match;
    }).replace(/Ã[^ ]/g, match => {
      return encodingMap[match] || match;
    });
  };
  
  export const detectEncoding = (buffer) => {
    // Détection simple basée sur les marqueurs BOM
    if (buffer[0] === 0xEF && buffer[1] === 0xBB && buffer[2] === 0xBF) {
      return 'UTF-8';
    }
    // Autres détections possibles...
    return 'windows-1252'; // Par défaut pour les fichiers français
  };